<template>
  <article class="post-it" :class="{ 'is-archived': archived, 'is-edit': !readonly }">
    <header class="post-it__head">
      <h5 class="post-it__title">{{ title }}</h5>
      <div v-if="readonly" class="post-it__actions">
        <button
          v-if="archived && canRestore"
          type="button"
          class="post-it__action"
          title="Desarquivar"
          @click="$emit('onRestoreClick')"
        >
          <i class="bi bi-arrow-counterclockwise"></i>
        </button>
        <button
          v-if="archived && canForceDelete"
          type="button"
          class="post-it__action is-danger"
          title="Excluir permanentemente"
          @click="$emit('onForceDeleteClick')"
        >
          <i class="bi bi-trash3"></i>
        </button>
        <button
          v-if="!archived && canArchive"
          type="button"
          class="post-it__action"
          title="Arquivar"
          @click="$emit('onArchiveClick')"
        >
          <i class="bi bi-archive"></i>
        </button>
      </div>
      <button
        v-else-if="canArchive"
        type="button"
        class="post-it__action"
        title="Cancelar"
        @click="$emit('onArchiveClick')"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </header>
    <textarea
      v-if="!readonly"
      class="post-it__input"
      v-model="localContent"
      ref="localContent"
      rows="3"
      placeholder="Escreva o recado..."
      @input="autoResize"
    ></textarea>
    <p
      v-else
      class="post-it__text"
      :class="{ 'is-archived': archived }"
    >{{ localContent }}</p>
    <div v-if="!readonly" class="post-it__foot">
      <button type="button" class="post-it__save" @click="updateContent">Salvar</button>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PostIt',
  props: {
    title: String,
    content: String,
    readonly: Boolean,
    archived: Boolean,
    canArchive: Boolean,
    canRestore: Boolean,
    canForceDelete: Boolean,
  },
  emits: ['onArchiveClick', 'onRestoreClick', 'onForceDeleteClick', 'onStoreClick'],
  data() {
    return {
      localContent: this.content,
    };
  },
  watch: {
    content(newVal) {
      this.localContent = newVal;
    },
  },
  mounted() {
    if (!this.readonly) {
      this.$refs.localContent.focus();
    }
  },
  methods: {
    updateContent() {
      this.$emit('onStoreClick', this.localContent);
    },
    autoResize(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
    },
  },
};
</script>

<style scoped>
.post-it {
  position: relative;
  margin: 0 0 0.55rem;
  padding: 0.7rem 0.75rem 0.65rem;
  background: linear-gradient(180deg, #fffaf0 0%, #fff6e0 100%);
  border: 1px solid #f0ddb4;
  border-radius: 0.7rem;
  box-shadow: 0 1px 0 rgba(180, 140, 60, 0.08);
}
.post-it.is-archived {
  background: linear-gradient(180deg, #f8f5f7 0%, #f3eef2 100%);
  border-color: #e4d5df;
}
.post-it.is-edit {
  background: #fffdf8;
  border-color: #e8d19a;
  box-shadow: inset 0 0 0 1px rgba(120, 15, 90, 0.04);
}
.post-it__head {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin-bottom: 0.35rem;
}
.post-it__title {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  color: #7a6a48;
  line-height: 1.3;
}
.post-it.is-archived .post-it__title {
  color: #7e8299;
}
.post-it__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
}
.post-it__action {
  flex-shrink: 0;
  width: 1.45rem;
  height: 1.45rem;
  padding: 0;
  border: 0;
  border-radius: 0.35rem;
  background: transparent;
  color: #c4a574;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.post-it__action:hover {
  background: rgba(120, 15, 90, 0.08);
  color: #780f5a;
}
.post-it__action.is-danger:hover {
  background: rgba(241, 65, 108, 0.1);
  color: #f1416c;
}
.post-it__action i {
  font-size: 0.78rem;
}
.post-it__text {
  margin: 0;
  color: #3f3a32;
  font-size: 0.8rem;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.post-it__text.is-archived {
  color: #7e8299;
}
.post-it__input {
  display: block;
  width: 100%;
  min-height: 4.2rem;
  margin: 0;
  padding: 0.45rem 0.5rem;
  border: 1px dashed #e4c98a;
  border-radius: 0.45rem;
  background: #fff;
  color: #3f3a32;
  font-size: 0.8rem;
  line-height: 1.45;
  resize: none;
  box-shadow: none;
}
.post-it__input:focus {
  outline: none;
  border-color: #780f5a;
  border-style: solid;
}
.post-it__foot {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.post-it__save {
  min-height: 1.85rem;
  padding: 0.2rem 0.75rem;
  border: 0;
  border-radius: 0.4rem;
  background: #780f5a;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
}
.post-it__save:hover {
  background: #65104c;
}
</style>
